export const mediaContainer = {
    m_width: '600px',
    m_padding: '10px',
}
export const mediaContainerWidth = {
    m_width: '600px',
    m_m_width: '100%',
}